import { render, staticRenderFns } from "./prestoreAccount.vue?vue&type=template&id=32b87ac4&scoped=true"
import script from "./prestoreAccount.vue?vue&type=script&lang=js"
export * from "./prestoreAccount.vue?vue&type=script&lang=js"
import style0 from "./prestoreAccount.vue?vue&type=style&index=0&id=32b87ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b87ac4",
  null
  
)

export default component.exports